import { render, staticRenderFns } from "./consigneeTable.vue?vue&type=template&id=83ee749c&scoped=true&"
import script from "./consigneeTable.vue?vue&type=script&lang=js&"
export * from "./consigneeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ee749c",
  null
  
)

export default component.exports